import React, { useState, useFocusEffect, useEffect, InputHTMLAttributes, label, form } from 'react';
import store from './redux/store';
import * as actions from './redux/actions.js'
import { APIvar } from '../services/variables';
import { redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import './login.css'
import { APICall } from './services/api.service';
import {ReactComponent as UserIcon} from '../images/icons/person-circle.svg';
import {ReactComponent as RegisterIcon} from '../images/icons/register.svg';
import {ReactComponent as ResetPasswordIcon} from '../images/icons/reset-password.svg';
import Logo from "../images/logo_atlas.png";


import { FiUser } from "react-icons/fi";
import { FiLock } from "react-icons/fi";


import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useColor = APIvar.colorUse;
const backColor = APIvar.colorBackground;



const LoginRegistration = () => {
    const dispatch = useDispatch()
    const [registrationEmail, setRegistrationEmail] = useState("");
    const [registrationPassword, setRegistrationPassword] = useState("");
    const [registrationOldPassword, setRegistrationOldPassword] = useState("")
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [isLoginVisible, setIsLoginVisible] = useState(true);
    const [isRegisterVisible, setIsRegisterVisible] = useState(false)
    const [showLogIn, setShowLogIn] = useState(true)
    const [showRegister, setShowRegister] = useState(false)
    const [showResetPassword, setShowResetPassord] = useState(false);

    const [privacyIsOpen, setPrivacyIsOpen] = useState(false);
    const [userDataIsOpen, setUserDataIsOpen] = useState(false);

    const [viewSignIn, setViewSignIn] = useState(false);

    const [workON, setWorkON] = useState(true);


    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 5000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 5000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };


   useEffect(()=>{
           document.title="Val - prijava"
   },[])

    const handleRegistration = (e) => {
        e.preventDefault();
        console.log("registration");

        console.log("Im registering here!");

        let unmounted = false;
   
        
        
        APICall(
            //'/changePassword',
            '/changePasswordVal',
            {
                user: registrationEmail,
                pass: registrationPassword,
                oldPass: registrationOldPassword,
                platform: '0',
                version:'1.0'



            }).then(
                
                (response)=> {

    
                        if (!unmounted) {
                
   
   
   
   
                                      var dataTmp = response.data;

                                      console.log(dataTmp);
   
   
   
                                      if(dataTmp && dataTmp.message !=""){
   

         
   
                                                toast.info(dataTmp.message,
                                                     toastInfo);
                                             
               
   
                                      } else {
                                            toast.error("Problem pri povezivanju sa serverom, molimo pokušajte kasnije",
                                                toastError);

                                      }
               
                        }
                
                },
    
                (error) => {
    
                       if (!unmounted) {
                
                
   
   
                
                            if(!error.response){
   
                                 toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                      toastError);
                              
   
   
                            } else {
   
   
                                 if(!error.response.status){
   
                                      toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                      toastError);
   
                                 }else{
    
                                      if (error.response.status == 401) {
                  
                               
                                           toast.error(error.response.data.message,
                                                toastError);
                                        
                                           setTimeout(() => {
                                                          //logOut();
                                           }, 5000);                             
                               
   
                                      
                                 
                                      } else {
                                 
                                 
                                                toast.error(error.response.data.message,
                                                     toastError);
                                                                               
                                           
                                      }
                                 }
                            }
                        
                       }
                
                
                });

    }

    const handleLogin = (e) => {
        e.preventDefault();

        console.log("Im logging in here!");
        //samo me prijavi

        
       APICall(
           
        //'/Login',
           '/LoginVal',
           {
                user: loginEmail,
                pass: loginPassword,
                platform: '0',
                version:'1.0'

            }).then((response)=> {
                console.log(response)

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    //let userData= response.data[0];
                    let userData = {
                        id: '', email: '', firstName: '', lastName: '',  token: '', name: '', 
                        adminDaily:'', adminNumeration:'', adminAll:'', adminDailyData:'', stat:'', allStat: '',
                        edit0600:'', edit0800:''
                    };
                    userData.token = response.data.token;
                    userData.email = response.data.user.email;
        

                    userData.id = response.data.user.ref;
                    userData.name = response.data.user.name;

                    console.log(userData.name);

                    console.log("Role in login:**************************")
                    console.log(response.data.user.role);

                    userData.adminDaily = response.data.user.role.val_daily_admin;
                    userData.adminNumeration = response.data.user.role.val_numeration_admin;

                    userData.adminAll = response.data.user.role.val_admin;
                    userData.adminDailyData = response.data.user.role.val_daily_data_admin;
                    userData.stat = response.data.user.role.val_daily_stat_ref;
                    userData.allStat = response.data.user.role.val_daily_stat_all_ref;
                    userData.edit0600 = response.data.user.role.val_060_edit;
                    userData.edit0800 = response.data.user.role.val_0800_edit;
              

                    let myArray = response.data.user.name.split(" ");
                    userData.firstName = myArray[0];
                    userData.lastName = myArray[1];

                    console.log("Setting up name: ");
                    console.log(userData);

        
        
                    dispatch(actions.logIn({
                        id:userData.id,
                        name:userData.name,
                        username:userData.email,
                        token:userData.token,
                        adminDaily: userData.adminDaily,
                        adminNumeration:userData.adminNumeration,

                        adminAll:userData.adminAll,
                        adminDailyData:userData.adminDailyData,
                        stat:userData.stat,
                        allStat : userData.allStat,
                        edit0600:userData.edit0600,
                        edit0800:userData.edit0800,
                        
                
                    }))

                    dispatch(actions.toggleSomeValue(0));
                }
                else if(response.status==401) { toast.error(response.data.msg, toastError);}
                else {toast.error("Došlo je do problema u povezivanju sa serverom, molimo pokušajte kasnije", toastError);}
                
            },
            (error) => {
    

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }

    return (
        <div className="login-registration">
        
            <div className="login-registration-tab">
                <div className="select-login" style={{backgroundColor: isLoginVisible? "#93aece": "unset"}}  onClick={()=> {
                    setIsLoginVisible(true)
                    setIsRegisterVisible(false)
                }}>
                    <UserIcon className="select-login-icon"/>
                </div>
                
                <div className="select-register" style={{backgroundColor: isRegisterVisible? "#93aece": "unset"}} onClick={()=> {
                    setIsLoginVisible(false)
                    setIsRegisterVisible(true)
                }}>
                    <RegisterIcon  className="select-register-icon"/>
                </div>

            </div>

            <div className="login-registration-container">

                <div className="login-registration-logo-container">
                    <img src={Logo} alt="Logo" className="login-registration-logo"/>

                </div>



                <div className="login-registration-form">
                    <div className="login-page" style={{ display: isLoginVisible? "unset" : "none" }}>


                        
                        <form className="login-page-form" onSubmit={(e)=>{handleLogin(e)}}>
                            <div className="inputContainer">
                                <FiUser className="ikona"/>
                                <input
                                        className="emailInputLogin"
                                        type='text'
                                        placeholder="Unesite korisničko ime"  
                                        onChange={e => {
                                            setLoginEmail(e.target.value)
                                        }}
                                />
                            </div>

                            <div className="inputContainer">
                                        <FiLock className="ikona"/>
                                        
                                        <input
                                            className="passwordInputLogin"
                                            type='password'
                                            placeholder="Unesite lozinku"  
                                            onChange={e => {

                                                setLoginPassword(e.target.value)
                                            }}
                                        />
                            </div>
                    
                                
  
                                


                            <div className="submitLogin">
                                <button type="submit" className='buttonLogIn'>Prijava</button>
                                            
                            </div>



                            </form>


                        


                    </div>

                    <div className="registration-page" style={{ display: isRegisterVisible? "unset" : "none" }}>


                            <form className="registration-page-form" onSubmit={(e)=>{handleRegistration(e)}}>
                               
                               
                                            <div className="inputContainer">
                                                    <FiUser className="ikona"/>
                                                    <input
                                                            className="emailInput"
                                                            type='text'
                                                            placeholder="Unesite korisničko ime"  
                                                            onChange={e => {
                                                                setRegistrationEmail(e.target.value)
                                                            }}
                                                    />
                                            </div>        

                                            <div className="inputContainer">
                                                    <FiLock className="ikona"/>
                                                    
                                                    <input
                                                        className="emailInput"
                                                        type='password'
                                                        placeholder="Unesite staru lozinku"  
                                                        onChange={e => {
                                                            setRegistrationOldPassword(e.target.value);
                                                            }}
                                                    />
                                                    
                                            </div>
                                            <div className="inputContainer">
                                                    <FiLock className="ikona"/>
                                                    <input
                                                        className="emailInput"
                                                        type='password'
                                                        placeholder="Unesite novu lozinku"  
                                                        onChange={e => {
                                                            setRegistrationPassword(e.target.value)
                                                            }}
                                                    />
                                            </div>        
                            
                                            <div className="submitRegistration">

                                                <button type="submit" className='buttonRegistration'>Promijeni lozinku</button>
                                            </div>

                                

                                
                            </form>
                        
                    </div>


                </div>


            </div>
          
            
            



        </div>
    );
};

export default LoginRegistration;
